import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  counter: {
    width: '36px',
    height: '36px',
    borderRadius: '2px',
    backgroundColor: palette.success.light,
    fontFamily: palette.fontFamilies.poppins,
    fontSize: '15px',
    lineHeight: '20px',
    fontWeight: '600',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer'
    },
    '& + &': {
      marginLeft: '4px'
    }
  },
  infoCounter: {
    backgroundColor: palette.info.light,
    color: palette.info.dark
  },
  successCounter: {
    backgroundColor: palette.success.light,
    color: palette.success.dark
  },
  successBoldCounter: {
    backgroundColor: palette.success.main,
    color: palette.shades[100]
  },
  warningCounter: {
    backgroundColor: palette.warning.light,
    color: palette.warning.dark
  },
  errorCounter: {
    backgroundColor: palette.error.light,
    color: palette.error.dark
  },
  utility: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0',
    '& .MuiSvgIcon-root': {
      marginRight: '10px'
    }
  }
});
export default useStyles;